<template>
  <div v-if="activeTab === 'configurations'" class="card card-outline-primary rounded-3 shadow">
    <div class="card-body p-0 px-4 py-3">
      <div class="d-flex justify-content-between align-items-center">
        <ul class="card-progress-tracker fw-bold text-center mb-0">
          <li :class="(workflowData && workflowData.workflow_completed && workflowData.workflow_completed.workflow_exists) ? 'completed': 'in-completed'">
            Workflow Created
          </li>
        </ul>
      </div>
      <transition name="slide-fade">
        <div class="row">
          <hr class="fw-light" />
          <div class="col-12">
            <div class="configurations-grid">
              <div class="config-item">
                <div class="config-card p-3 border rounded-3 h-100">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <div class="config-icon me-3">
                        <i class="bi bi-people-fill"></i>
                      </div>
                      <div>
                        <div class="fw-semibold mb-1 text-muted fs-6">Multiple Onboarding</div>
                        <div class="text-muted text-xs">Allow multiple onboarding per customer</div>
                      </div>
                    </div>
                    <div class="config-status">
                      <span :class="['badge', allowMultipleOnboarding ? 'bg-success' : 'bg-secondary']">
                        {{ allowMultipleOnboarding ? 'Enabled' : 'Disabled' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="config-item">
                <div class="config-card p-3 border rounded-3 h-100">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <div class="config-icon me-3">
                        <i class="bi bi-cloud-upload-fill"></i>
                      </div>
                      <div>
                        <div class="fw-semibold mb-1 text-muted fs-6">API Storage</div>
                        <div class="text-muted text-xs">Store service results for external API retrieval</div>
                      </div>
                    </div>
                    <div class="config-status">
                      <span :class="['badge', storeApiWorkflow ? 'bg-success' : 'bg-secondary']">
                        {{ storeApiWorkflow ? 'Enabled' : 'Disabled' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="config-item">
                <div class="config-card p-3 border rounded-3 h-100">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <div class="config-icon me-3">
                        <i class="bi bi-share-fill"></i>
                      </div>
                      <div>
                        <div class="fw-semibold mb-1 text-muted fs-6">On Behalf Of Prepopulation</div>
                        <div class="text-muted text-xs">Allow "on behalf of" sub workflows to use prepopulation settings</div>
                      </div>
                    </div>
                    <div class="config-status">
                      <span :class="['badge', onBehalfOfPrepopulation ? 'bg-success' : 'bg-secondary']">
                        {{ onBehalfOfPrepopulation ? 'Enabled' : 'Disabled' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="config-item">
                <div class="config-card p-3 border rounded-3 h-100">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <div class="config-icon me-3">
                        <i class="bi bi-people-fill"></i>
                      </div>
                      <div>
                        <div class="fw-semibold mb-1 text-muted fs-7">Batch Upload</div>
                        <div class="text-muted text-xs">Allow customer to do batch upload</div>
                      </div>
                    </div>
                    <div class="config-status">
                      <span :class="['badge', allowBatchOnboarding ? 'bg-success' : 'bg-secondary']">
                        {{ allowBatchOnboarding ? 'Enabled' : 'Disabled' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfigurationsTab',
  props: {
    activeTab: {
      type: String,
      default: 'configurations'
    },
    workflowData: {
      type: Object,
      default: null
    },
    allowMultipleOnboarding: {
      type: Boolean,
      default: false
    },
    storeApiWorkflow: {
      type: Boolean,
      default: false
    },
    onBehalfOfPrepopulation: {
      type: Boolean,
      default: false
    },
    allowBatchOnboarding: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.configurations-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.config-item {
  display: flex;
}

.config-card {
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  width: 100%;
}

.config-icon {
  border-radius: 8px;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  color: var(--primary-color);
}

.fs-7 {
  font-size: 14px;
}

.fw-semibold {
  font-weight: 600;
}
</style>
